import { Icons, Item, MenuOptionItem, Select } from "widgets";

import { useGetOrganismsQuery } from "@/modules/workflow/graphql/coordinate-lists.gql.ts";

export const GenomeSelect = ({
  availableGenomesIds,
  selectedId,
  onChange,
}: {
  availableGenomesIds: number[];
  selectedId?: number;
  onChange: (orgId: number) => void;
}) => {
  const { data, loading } = useGetOrganismsQuery({
    variables: { orgIds: availableGenomesIds },
  });

  const items = data?.organisms ?? [];
  const selectedKey = String(selectedId ?? items[0]?.id ?? "");

  return (
    <Select
      items={items}
      isDisabled={loading}
      onSelectionChange={(key) => onChange(Number(key))}
      selectedKey={selectedKey}
      icon={<img src={Icons.Tiles.Entity} width={20} height={20} alt="" />}
    >
      {(item) => (
        <Item key={String(item.id)} textValue={item.name ?? undefined}>
          <MenuOptionItem title={item.name} />
        </Item>
      )}
    </Select>
  );
};
